module.exports = __webpack_public_path__ + "img/logo_tv.97761d30.png";